module.exports = __webpack_public_path__ + "static/media/no-image.e2e1775d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/no-image.png
 ** module id = 466
 ** module chunks = 0
 **/